import {
  createMutationStore,
  createQueryStore,
  createPersistedStore,
} from '@ferreri/minato-react-utils';
import { useCurrentPlanOrderId } from '../order/order.store';
import { getCoupon, updateOrderCoupon } from './coupons.client';
import { useEffect } from 'react';

export const useCoupon = (promocode: string) => {
  return createQueryStore({
    queryKey: ['coupon', promocode],
    queryFn: () => getCoupon(promocode),
    enabled: !!promocode,
    retry: false,
    refetchOnWindowFocus: false,
  });
};

export const useSavedPromocode = () =>
  createPersistedStore<string>('saved_promocode');

export const useUpdateOrderCoupon = (config = null) => {
  const orderId = useCurrentPlanOrderId();

  return createMutationStore({
    mutationFn: async (promocode: string) =>
      updateOrderCoupon(promocode, orderId),
    ...config,
  });
};

export const useCurrentCodeCoupon = () => {
  const [promocode] = useSavedPromocode();

  return promocode;
};

export const useCurrentCoupon = () => {
  return useCoupon(useCurrentCodeCoupon());
};

export const useSaveCoupon = (promocode: string) => {
  const {
    data: coupon,
    isSuccess: isSuccessGetCoupon,
    isLoading: isLoadingGetCoupon,
  } = useCoupon(promocode);
  const [, savePromocode] = useSavedPromocode();

  useEffect(() => {
    if (isSuccessGetCoupon) {
      savePromocode(promocode as string);
    }
  }, [isSuccessGetCoupon]);

  return {
    data: coupon,
    isLoading: isLoadingGetCoupon,
    isSuccess: isSuccessGetCoupon,
  };
};
